import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import styles from '../style/NotFound.module.css';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <motion.div 
                    className={styles.headerSection}
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.1 }}
                >
                    <div className={styles.badge}>System Error_0x404</div>
                    <h1 className={styles.title}>Signal Lost in Cyberspace</h1>
                </motion.div>

                <motion.div 
                    className={styles.visualSection}
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8 }}
                >
                    <div className={styles.glow} />
                    <div className={styles.terminalCard}>
                        <div className={styles.terminalHeader}>
                            <div className={`${styles.terminalDot} ${styles.redDot}`}></div>
                            <div className={`${styles.terminalDot} ${styles.yellowDot}`}></div>
                            <div className={`${styles.terminalDot} ${styles.greenDot}`}></div>
                            <span className={styles.terminalTitle}>system_core.log</span>
                        </div>
                        <div className={styles.terminalBody}>
                            <p className={styles.codeLine}><span className={styles.codeKeyword}>const</span> <span className={styles.codeVar}>status</span> = <span className={styles.codeString}>"LOST_IN_SPACE"</span>;</p>
                            <p className={styles.codeLine}><span className={styles.codeKeyword}>if</span> (<span className={styles.codeVar}>status</span> === <span className={styles.codeString}>"LOST_IN_SPACE"</span>) &#123;</p>
                            <p className={styles.codeIndent}><span className={styles.codeKeyword}>throw new</span> <span className={styles.codeClass}>Error</span>(<span className={styles.codeNum}>404</span>);</p>
                            <p className={styles.codeLine}>&#125;</p>
                            <div className={styles.terminalDivider} />
                            <p className={styles.systemLog}>[info] Initializing system grid scan...</p>
                            <p className={styles.systemLog}>[warn] No server nodes found matching search queries.</p>
                            <p className={styles.systemError}>[fatal] Connection timed out. Session terminated.</p>
                        </div>
                    </div>
                    <motion.div 
                        className={styles.errorNumber}
                        animate={{ 
                            y: [0, -15, 0],
                        }}
                        transition={{ 
                            repeat: Infinity, 
                            duration: 4, 
                            ease: "easeInOut" 
                        }}
                    >
                        4<span>0</span>4
                    </motion.div>
                </motion.div>

                <motion.div 
                    className={styles.detailsSection}
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.2 }}
                >
                    <p className={styles.description}>
                        The page you're searching for has been moved, deleted, or never existed in this dimension. 
                        Let's get you back to the main grid.
                    </p>

                    <div className={styles.actions}>
                        <button 
                            className={styles.primaryBtn} 
                            onClick={() => navigate('/')}
                        >
                            <Home size={20} /> Go to Home
                        </button>
                        <button 
                            className={styles.secondaryBtn} 
                            onClick={() => navigate(-1)}
                        >
                            <ArrowLeft size={20} /> Previous Route
                        </button>
                    </div>

                    <div className={styles.shortcuts}>
                        <span className={styles.shortcutLabel}>Quick Links:</span>
                        <div className={styles.links}>
                            <span onClick={() => navigate('/blogs')}>Blogs</span>
                            <span onClick={() => navigate('/portfolio')}>Portfolio</span>
                            <span onClick={() => navigate('/contact')}>Contact</span>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default NotFound;
